import { render, staticRenderFns } from "./AddStudentInAlbumDialog.vue?vue&type=template&id=1f9552e4&scoped=true"
import script from "./AddStudentInAlbumDialog.vue?vue&type=script&lang=js"
export * from "./AddStudentInAlbumDialog.vue?vue&type=script&lang=js"
import style0 from "./AddStudentInAlbumDialog.vue?vue&type=style&index=0&id=1f9552e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9552e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9552e4')) {
      api.createRecord('1f9552e4', component.options)
    } else {
      api.reload('1f9552e4', component.options)
    }
    module.hot.accept("./AddStudentInAlbumDialog.vue?vue&type=template&id=1f9552e4&scoped=true", function () {
      api.rerender('1f9552e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/album/AddStudentInAlbumDialog.vue"
export default component.exports